module.exports = __webpack_public_path__ + "img/der_02_xrobot_b.6be91fde.png";